import { isNumber } from "lodash";
import { forwardRef } from "react";

import type { Icon, IconProps } from "@tabler/icons-react";

export const IconFilterTable = forwardRef<Icon, IconProps>(
  ({ size = 24, stroke = "none", ...props }, ref) => {
    const currentStroke = isNumber(stroke) ? `${stroke}px` : stroke;

    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="currentColor"
        stroke={currentStroke}
        {...props}
        ref={ref as any}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.5 15C9.5 14.1716 8.82843 13.5 8 13.5C7.17157 13.5 6.5 14.1716 6.5 15C6.5 15.8284 7.17157 16.5 8 16.5C8.82843 16.5 9.5 15.8284 9.5 15ZM11 15C11 13.6938 10.1652 12.5825 9 12.1707L9 5C9 4.44771 8.55228 4 8 4C7.44771 4 7 4.44771 7 5L7 12.1707C5.83481 12.5825 5 13.6938 5 15C5 16.3062 5.83481 17.4175 7 17.8293L7 19C7 19.5523 7.44772 20 8 20C8.55228 20 9 19.5523 9 19V17.8293C10.1652 17.4175 11 16.3062 11 15ZM14.5 9C14.5 9.82843 15.1716 10.5 16 10.5C16.8284 10.5 17.5 9.82843 17.5 9C17.5 8.17157 16.8284 7.5 16 7.5C15.1716 7.5 14.5 8.17157 14.5 9ZM13 9C13 10.3062 13.8348 11.4175 15 11.8293L15 19C15 19.5523 15.4477 20 16 20C16.5523 20 17 19.5523 17 19L17 11.8293C18.1652 11.4175 19 10.3062 19 9C19 7.69378 18.1652 6.58254 17 6.17071V5C17 4.44772 16.5523 4 16 4C15.4477 4 15 4.44772 15 5V6.17071C13.8348 6.58254 13 7.69378 13 9Z"
        />
      </svg>
    );
  }
);
